<script>
  import { slide } from "svelte-transitions";
  import { auth, db } from "../firebase";
  import { createEventDispatcher } from "svelte";

  export let title;
  export let interestRate;
  export let numberOfYears;
  export let loanAmount;
  export let state;
  export let creditScore;
  export let borrowerCount;
  export let closingDate;

  let optionSelected = false;
  let borrowerName = "",
    borrowerPhone = "",
    borrowerEmail = "",
    coborrowerName = "",
    coborrowerPhone = "",
    coborrowerEmail = "";
  let perMonth = calculateLoanDetails().toFixed(2);

  const dispatch = createEventDispatcher();
  function optionSubmitted(data) {
    dispatch("optionSubmitted", data);
  }

  function calculateLoanDetails() {
    const n = numberOfYears * 12;
    const r = interestRate / 100 / 12;
    const pow = Math.pow(1 + r, n);
    return (loanAmount + 100) * ((r * pow) / (pow - 1));
  }

  function sumbitOption() {
    const monthlyPayment = calculateLoanDetails();
    const user = JSON.parse(localStorage.getItem("user"));
    const loanOption = {
      title: title,
      interestRate: interestRate,
      loanAmount: loanAmount,
      state: state,
      monthlyPayment: monthlyPayment,
      closingDate: closingDate ? closingDate : null,
      borrowerName: borrowerName,
      borrowerPhone: borrowerPhone,
      borrowerEmail: borrowerEmail,
      coborrowerName: coborrowerName,
      coborrowerPhone: coborrowerPhone,
      coborrowerEmail: coborrowerEmail,
      submittedUser: user.uid,
      loEmail: user.email,
      loName: user.firstName + " " + user.lastName,
      creditScore: creditScore,
      numberOfYears: numberOfYears,
      completed: false,
      created: Date.now()
    };

    try {
      db.collection("users")
        .doc(auth.currentUser.uid)
        .collection("submittedLoans")
        .add(loanOption)
        .then(function() {
        })
        .catch(function(error) {
          console.error("Error writing document: ", error);
          alert('If you are seeing this there has been an error submitting your loan. Please notify us via email. Error: ' + JSON.stringify(error));
        });

      db.collection("submittedLoans")
        .add(loanOption)
        .then(function() {
          optionSubmitted(loanOption);
        })
        .catch(function(error) {
          console.error("Error writing document: ", error);
          alert('If you are seeing this there has been an error submitting your loan. Please notify us via email. Error: ' + JSON.stringify(error));
        });
    } catch (error) {
      alert('If you are seeing this there has been an error submitting your loan. Please notify us via email. Error: ' + JSON.stringify(error));
      console.error("Error saving loan: ", error);
    }
  }
</script>

<div class="card mb-4 box-shadow">
  <div class="card-header">
    <h4 class="my-0 font-weight-normal">{title}</h4>
  </div>
  <div class="card-body">
    <h1 class="card-title pricing-card-title">
      ${perMonth}
      <small class="text-muted">/ mo</small>
    </h1>
    <ul class="list-unstyled mt-3 mb-4">
      <li>{interestRate}% Rate</li>
    </ul>

    {#if optionSelected}
      <div in:slide>
        <form
          style="text-align: center;"
          on:submit|preventDefault={sumbitOption}>
          <h4>Borrower Data</h4>
          <div class="form-group">
            <input
              type="text"
              class="form-control text-center"
              aria-describedby="borrowerName"
              placeholder="Full Name"
              bind:value={borrowerName} />
            <input
              type="text"
              class="form-control text-center"
              aria-describedby="borrowerPhone"
              placeholder="Phone Number"
              bind:value={borrowerPhone} />
            <input
              type="email"
              class="form-control text-center"
              aria-describedby="borrowerEmail"
              placeholder="Email"
              bind:value={borrowerEmail} />
          </div>
          {#if borrowerCount == 2}
            <h4>Coborrower Data</h4>
            <div class="form-group">
              <input
                type="text"
                class="form-control text-center"
                aria-describedby="coborrowerName"
                placeholder="Full Name"
                bind:value={coborrowerName} />
              <input
                type="text"
                class="form-control text-center"
                aria-describedby="coborrowerPhone"
                placeholder="Phone Number"
                bind:value={coborrowerPhone} />
              <input
                type="text"
                class="form-control text-center"
                aria-describedby="coborrowerEmail"
                placeholder="Email"
                bind:value={coborrowerEmail} />
            </div>
          {/if}
          <button type="submit" class="btn btn-lg btn-block btn-success">
            Confirm
          </button>
        </form>
      </div>
    {:else}
      <div>
        <button
          type="button"
          on:click={() => (optionSelected = true)}
          class="btn btn-lg btn-block btn-primary">
          Select
        </button>
      </div>
    {/if}
  </div>
</div>
